
<a *ngIf="chatShow()" href="https://tawk.to/chat/6214840ca34c245641277924/1fsg27kch" target="_blank" class="live__chat">
  <i class="icofont-chat"></i>
</a>

<div id="footer" class="bottom-tabs d-md-none">
    <span class="bottom-image"></span>
    <ul>
        <li class="truncate all-sports lpsport">
          <a href="javascript:void(0)" id="menu-toggle" (click)="toggleMenu()">
            <i class="icofont-menuclose"></i>
          </a>
          <div class="title-name">Menu</div>
        </li>
        <li class="truncate lpinplay">
          <a href="javascript:void(0);" routerLink="/dashboard" routerLinkActive="active-menu">
            <i class="icofont-clock-time"></i>
          </a>
          <div class="title-name">In Play</div>
        </li>
        <li class="truncate"><a href="javascript:void(0)" class="blank-bg">&nbsp;</a></li>
        <li class="big">
          <a href="/home" routerlink="/home" class="bowler" ng-reflect-router-link="/home">
            <i class="icofont-home"></i>
          </a>
        </li>
        <li class="truncate lpcasomp">
            <a routerLink="/exchange_sports/99995">
              <i class="icofont-woman-bird"></i>
            </a>
            <div class="title-name">Casino</div>
        </li>
        <li class="truncate promotion lppromotion">
          <a href="javascript:void(0);" [routerLink]="['/promotion']" routerLinkActive="active-menu">
            <i class="icofont-megaphone-alt"></i>
            <div class="title-name">Promotion</div>
          </a>
        </li>
        
        <!-- <li class="truncate promotion lppromotion">
          <a href="javascript:void(0);" (click)="confirmBox()">
            <i class="icofont-user"></i>
            <div class="title-name">My Bets</div>
          </a>
        </li> -->
    </ul>
</div>


 <!-- mobile footer -->
 <!-- <div class="mobile-menu">
    <nav class="mobile-bottom-nav col-xl-none">
      <a class="mbn-col-3" href="javascript:void(0)" id="menu-toggle" (click)="toggleMenu()">
        <i class="icofont-menuclose"></i>
          <span>menu</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" routerLink="/home" routerLinkActive="active-menu">
        <i class="icofont-home"></i>
          <span>home</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" routerLink="/dashboard" routerLinkActive="active-menu">
        <i class="icofont-clock-time"></i>
          <span>inplay</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" (click)="confirmBox()">
        <i class="icofont-user"></i>
          <span>my bets</span>
      </a>
    </nav>
  </div> --> 
  <!-- mobile footer -->